import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useCountUp } from 'react-countup'
import { Waypoint } from 'react-waypoint'

// Components
import Slider from '../../../Slider'
import Text from '../../../Text'

// Styles
import styles from './YearsInHomeSlider.module.scss'

const propTypes = {
  className: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
  value: PropTypes.number
}

const defaultProps = {
  min: 1,
  max: 30
}

const YearsCaption = ({ value }) => (
  <FormattedMessage
    id='RefiByYearsInHome.YearsLabel'
    defaultMessage='{years} {years, plural, one {year} other {years}}'
    values={{
      years: value
    }}
  />
)

YearsCaption.propTypes = {
  value: PropTypes.string
}

export const YearsInHomeSlider = ({ min, max, value, ...restProps }) => {
  const [animating, setAnimating] = useState(false)
  const [hasAnimated, setHasAnimated] = useState(false)
  const { countUp, start } = useCountUp({
    start: 0,
    end: value,
    onEnd: () => {
      setAnimating(false)
    }
  })

  const startAnimating = useCallback(start, [])

  useEffect(() => {
    if (animating) {
      startAnimating()
      setHasAnimated(true)
    }
  }, [animating, startAnimating])

  return (
    <>
      <Text
        variant='neutralCool'
        variantCount='700'
        align='center'
        size='s'
        weight='light'
        paragraph
        className={styles.label}
      >
        <FormattedMessage
          id='RefiByYearsInHome.sliderLabel'
          defaultMessage='It depends: How many {moreYears} will you keep this home?'
          values={{
            moreYears: (
              <Text.Strong>
                <FormattedMessage id='RefiByYearsInHome.sliderLabel.moreYears' defaultMessage='more years' />
              </Text.Strong>
            )
          }}
        />
      </Text>
      <Slider
        name='yearsInHome'
        data-qa='yearsInHomeSlider'
        value={animating ? countUp : value}
        min={min}
        max={max}
        minPhrase={<YearsCaption value={min} />}
        maxPhrase={<YearsCaption value={max} />}
        {...restProps}
      />
      <Waypoint
        onEnter={() => {
          if (!hasAnimated) {
            setAnimating(true)
          }
        }}
        bottomOffset='150px'
      >
        <div />
      </Waypoint>
    </>
  )
}

YearsInHomeSlider.propTypes = propTypes
YearsInHomeSlider.defaultProps = defaultProps
